<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row
    class="ma-0"
    dense
  >
    <v-col class="pa-0">
      <ExplorerTabs
        ref="explorer-tabs"
        :storage-data="storageData"
        model="checklists"
      >
        <template v-slot:explorer-tab>
          <v-divider />
          <PKCChecklistsTable
            @openItem="openChecklist"
          />
        </template>
        <template v-slot:details-tab="{slot_id}">
          <PKCChecklistDetailsTab
            :checklist-id="slot_id"
          />
        </template>
      </ExplorerTabs>
    </v-col>
  </v-row>
</template>

<script>
  import ExplorerTabs from '@/components/repository/explorers/ExplorerTabs'
  import model_process from '@/constants/models/model_process'
  import vuex_management from '@/store/modules/sections/vuex_management'
  import PKCChecklistDetailsTab from '@/components/management/processManagement/PKCChecklistDetailsTab.vue'
  import PKCChecklistsTable from '@/components/management/processManagement/PKCChecklistsTable.vue'

  export default {
    name: 'PKCChecklistsView',
    components: {
      PKCChecklistsTable,
      PKCChecklistDetailsTab,
      ExplorerTabs
    },
    data() {
      return {
        model_process,
        storageData: {
          namespace: vuex_management.constants.NAMESPACE,
          state: vuex_management.constants.S_CHECKLIST_OPENED,
          action: vuex_management.constants.A_SET_CHECKLIST_OPENED
        }
      }
    },
    methods: {
      openChecklist(checklist) {
        this.$refs['explorer-tabs'].changeTab({
          id: `${checklist['id']}`, // Conversión implícita a string
          name: `${checklist['process_name']} v${checklist['version']}`,
          version: checklist['version'].toString()
        })
      }
    }
  }
</script>